import React from "react";
import { UserManagementView } from "@rankmi/ats-app";


const OrganizationUsers = () => {
  return (
    <UserManagementView/>
  );
};

export default OrganizationUsers;